module.exports = __webpack_public_path__ + "static/mike-lapeter-2018-a4f759e40166681f5617e5ff829b2bb5.jpg";